import { HttpClient } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { ApiResponse, Country } from '@app/shared/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  http = inject(HttpClient);

  constructor(@Inject('apiUrl') private apiUrl: string) {}

  getCountries(): Observable<Country[]> {
    return this.http.get<ApiResponse<Country[]>>(`${this.apiUrl}/countries`).pipe(map((response) => response.data));
  }
}
